import { Controller } from '@hotwired/stimulus'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import ImportExcelTemplate from '@/components/import_excel_template.vue'
import SelectButton from 'primevue/selectbutton'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

axios.defaults.headers.common['X-CSRF-Token'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')
export default class extends Controller {
  static targets = ['template']
  connect() {
    const app = createApp(ImportExcelTemplate, {
      department: JSON.parse(this.element.dataset.department),
      workPeriods: JSON.parse(this.element.dataset.workPeriods),
      initWorkPeriod: JSON.parse(this.element.dataset.initWorkPeriod),
      creatorWorks: JSON.parse(this.element.dataset.creatorWorks) || []
    })
    app.use(PrimeVue)
    app.component('SelectButton', SelectButton)
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.templateTarget)
  }
}
